import 'vue-slider-component/theme/default.css'
import 'vuetify/dist/vuetify.min.css'

import * as Integrations from '@sentry/integrations'
import * as Sentry from '@sentry/browser'
import * as VueGoogleMaps from 'vue2-google-maps'

import { Chart, registerables } from 'chart.js'
import { Drag, Drop } from 'vue-drag-drop'

import ApolloProvider from './apollo'
import App from './App.vue'
import VModal from 'vue-js-modal'
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import VueDraggableResizable from 'vue-draggable-resizable'
import VueSocialSharing from 'vue-social-sharing'
import Vuelidate from 'vuelidate'
import Vuetify from 'vuetify'
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete'
import i18next from 'i18next'
import I18NextVue from 'i18next-vue'
import LanguageDetector from 'i18next-browser-languagedetector'
import translation from './assets/translation.ts'
import { router } from './routing/'

Chart.register(...registerables)

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_DSN,
  environment: process.env.VUE_APP_ENVIRONMENT,
  integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  enabled: process.env.VUE_APP_ENVIRONMENT !== 'development',
})

Vue.use(VueSocialSharing)
Vue.component('vue-draggable-resizable', VueDraggableResizable)

Vue.config.productionTip = process.env.VUE_APP_ENVIRONMENT === 'production'
Vue.component('drag', Drag)
Vue.component('drop', Drop)
Vue.use(Vuelidate)
Vue.use(VueClipboard)

Vue.directive('hide', {
  update(el, binding) {
    if (binding.value) el.style.visibility = 'hidden'
    else el.style.visibility = 'visible'
  },
})

Vue.directive('click-outside', {
  bind() {
    this.event = event => this.vm.$emit(this.expression, event)
    this.el.addEventListener('click', this.stopProp)
    document.body.addEventListener('click', this.event)
  },
  unbind() {
    this.el.removeEventListener('click', this.stopProp)
    document.body.removeEventListener('click', this.event)
  },

  stopProp(event) {
    event.stopPropagation()
  },
})

Vue.use(Vuetify, {
  theme: {
    primary: '#0277BD',
    secondary: '#FF4C00',
    accent: '#0277BD',
    error: '#DB384C',
    errorDark: '#BD2A3C',
    info: '#0277BD',
    success: '#4CAF50',
    warning: '#FFC107',
    dinamoBlue: '#0054A5',
    grey_00: '#333',
  },
})

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_PLACES_API_KEY,
    libraries: 'places',
  },
})

Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: process.env.VUE_APP_GOOGLE_PLACES_API_KEY,
})

Vue.use(VModal, { componentName: 'vue-modal' })

require('blueimp-canvas-to-blob')
require('cropperjs/dist/cropper.css')
require('./mixins')
require('./directives')
require('./components/shared/inputs')
require('./components/shared/main-button')
require('./components/shared/spinner')

Vue.use(I18NextVue, {
  i18next,
})

// i18next is only used on pages that customers see (registration,etc) this is not for general application translations
i18next.on('initialized', async () => {
  i18next.addResourceBundle('en', 'default', translation.en.default, true, false)
  i18next.addResourceBundle('hr', 'default', translation.hr.default, true, false)
  await i18next.changeLanguage('en')

  new Vue({
    router,
    render: h => h(App),
    apolloProvider: ApolloProvider,
  }).$mount('#app')
})

// When we land on the registration form we check the query params for a lang
// which will set everything apart from custom attendee fields which have their own translation
const getFallbackLanguageCodeFromQueryParams = () => {
  const params = new URL(window.location.href).searchParams

  return params.get('lang') || 'en'
}

i18next.use(LanguageDetector).init({
  debug: false,
  fallbackLng: getFallbackLanguageCodeFromQueryParams(window.location.href),
  ns: [],
  defaultNS: 'default',
  partialBundledLanguages: true,
  resources: {},
})
